
import { mapState, mapGetters } from "vuex";
import { Component, Vue, Watch } from "vue-property-decorator";
import InterestAreaFilter from "@/components/BrochureAanvraag/InterestAreaFilter.vue";
import StudyLanguageFilter from "@/components/BrochureAanvraag/StudyLanguageFilter.vue";
import StudyTypeFilter from "@/components/BrochureAanvraag/StudyTypeFilter.vue";
import StudyFormFilter from "@/components/BrochureAanvraag/StudyFormFilter.vue";
import SearchFilter from "@/components/BrochureAanvraag/SearchFilter.vue";
import SessionList from "@/components/BrochureAanvraag/SessionList.vue";
import SelectedBrochures from "@/components/BrochureAanvraag/SelectedBrochures.vue";
import Brochure from "@/models/Brochure";
import * as Moment from "moment";
import moment from "moment";
import { extendMoment } from "moment-range";
import InterestArea from "@/models/InterestArea";
import SubjectFilter from "@/components/BrochureAanvraag/SubjectFilter.vue";
import ShippingMethodFilter from "@/components/BrochureAanvraag/ShippingMethodFilter.vue";
import ShippingMethod from "@/models/ShippingMethod";

interface Window {

  showAddressFields(): void;
  hideAddressFields(): void;

}

@Component({
  components: {
    InterestAreaFilter,
    StudyLanguageFilter,
    StudyTypeFilter,
    StudyFormFilter,
    SubjectFilter,
    ShippingMethodFilter,
    SearchFilter,
    SelectedBrochures,
    SessionList
  },
  computed: {
    ...mapState("BrochureAanvraag", [
      "loading",
      "selectedBrochures"
    ]),
    ...mapGetters("BrochureAanvraag", ["Event", "SessionDatesLength", "GetFilteredBrochuresCount"])
  }
})
export default class BrochureAanvraag extends Vue {
  currentStep = 1;
  showAlert = false;
  alertText = "";
  numberOfSelectedBrochures = 0;
  dialog = false;
  mobile = false;
  windowWidth = 2000;

  data() {
    return {
      windowWidth: window.innerWidth
    }
  }
  mounted() {
    window.onresize = () => {
      this.windowWidth = window.innerWidth
      this.mobile = this.windowWidth < 700;
    }
  }

  hideAlert() {
    this.showAlert = false;
  }

  async created() {

    this.mobile = this.windowWidth < 700;

    if (this.$route.query.hc) {
      this.$store.commit("BrochureAanvraag/vlsChanged", this.$route.query.hc);
    } else {
      this.$store.commit("BrochureAanvraag/vlsChanged", "");
    }
    await this.$store.dispatch("BrochureAanvraag/loadSessionData");

    if (this.$route.query.hc) {

      var brochure = this.$store.state.BrochureAanvraag.brochures.filter((b: Brochure) => b.code == this.$route.query.hc);

      if (brochure != null && brochure.length > 0) {
        this.$store.commit("BrochureAanvraag/changeSelection", {
          id: brochure[0].id,
          selected: true
        });
      }
    }

    this.SetShippingMethodFilterByName(this.$route.query.ship?.toString());
  }



  removeAllFilters() {

    //remove InterestAreaFilter
    const InterestAreaFilterComponent = this.$refs
      .InterestAreaFilterComponentref as InterestAreaFilter;
    if (InterestAreaFilterComponent) InterestAreaFilterComponent.selected = [];

    //remove StudyLanguageFilter
    const studyLanguagefilter = this.$refs
      .StudyLanguageFilterComponentref as StudyLanguageFilter;
    if (studyLanguagefilter) studyLanguagefilter.selected = [];

    //remove StudyTypeFilter
    const StudyTypeFilterComponent = this.$refs
      .StudyTypeFilterComponentref as StudyTypeFilter;
    if (StudyTypeFilterComponent) StudyTypeFilterComponent.selected = [];

    //remove StudyForm
    const StudyFormFilterComponent = this.$refs
      .StudyFormFilterComponentref as StudyFormFilter;
    if (StudyFormFilterComponent) StudyFormFilterComponent.selected = [];

    //remove StudyChoice
    const StudyChoiceFilterComponent = this.$refs
      .StudyChoiceFilterComponentref as SubjectFilter;
    if (StudyChoiceFilterComponent) StudyChoiceFilterComponent.selected = [];

    //remove ShippingMethodFilter
    const ShippingMethodFilterComponent = this.$refs
      .ShippingMethodFilterComponentref as ShippingMethodFilter;
    if (ShippingMethodFilterComponent) ShippingMethodFilterComponent.selected = [];

    this.$store.commit("BrochureAanvraag/recalculateFilters");
  }

  recalculateFilters() {
    this.$store.commit("BrochureAanvraag/recalculateFilters");
  }

  @Watch("selectedBrochures", { immediate: true })
  selectedBrochuresChanged(sessionIds: string[]) {
    this.numberOfSelectedBrochures = sessionIds.length;
  }

  changeStep(stepnr: number) {
    const entityform = document.getElementById("entityform") as HTMLDivElement;
    const sessionsPanel = document.getElementById("brochures") as HTMLDivElement;

    if (stepnr == 2) {

      if (this.numberOfSelectedBrochures < 1) {
        this.showAlert = true;
        this.alertText = this.$tc("er.minimumBrochures");
        return;
      }

      const postbrochures =
        this.$store.state.BrochureAanvraag.selectedBrochures
          .map((id: string) => {
            return this.$store.state.BrochureAanvraag.brochuresById[id];
          })
          .filter((s: Brochure) => s.shippingmethod?.id == "806970001");


      if (postbrochures.length > 0) {
        window.showAddressFields();
      }
      else {
        window.hideAddressFields();
      }

      this.currentStep = 2;
      sessionsPanel.style.display = "none";
      entityform.style.display = "block";
      window.scrollTo(0, 0)
    }
    if (stepnr == 1) {
      this.currentStep = 1;

      sessionsPanel.style.display = "block";
      entityform.style.display = "none";
      window.hideAddressFields();
    }
  }

  get nextButtonDisabled() {
    if (this.$store.state.BrochureAanvraag.selectedBrochures.length == 0)
      return true;

  }

  SetShippingMethodFilterByName(shippingMethodName: string) {
    if (shippingMethodName != null) {
      const shippingMethod = this.$store.state.BrochureAanvraag.shippingMethods.filter((l: ShippingMethod) => l.name.toLocaleLowerCase() == shippingMethodName.toLocaleLowerCase());
      if (shippingMethod != null && shippingMethod.length > 0) {
        this.SetShippingMethodFilter(shippingMethod[0].id);
      }
    }
  }

  SetShippingMethodFilter(shippingMethodId: string) {
    if (shippingMethodId != null) {

      let selectedIds: string[] = [];
      selectedIds.push(shippingMethodId);

      const ShippingMethodFilterComponent = this.$refs
        .ShippingMethodFilterComponentref as ShippingMethodFilter;
      if (ShippingMethodFilterComponent) ShippingMethodFilterComponent.selected = selectedIds;

    }

  }
}
